import { all, call, put, takeLatest, takeEvery } from 'redux-saga/effects'
import { formatNumber, localToken, userId } from '../../components/helpers'
import { api, headers, tableKeys, TOKEN_TYPE } from '../../constants/constants'
import { fetchTableData } from '../actions/table'

const url = (key, projectId) => {
  switch(key) {
    case tableKeys.budget_documents_table:
      return api.budget_base + api.budget_documents + api.budget + '?projectId=' + projectId
    case tableKeys.budget_lines_table:
      return api.projects_base + api.budget_categories + '?projectId=' + projectId + '&elem=100&page=0'
    case tableKeys.budget_contracts_table:
      return api.budget_base + api.budget_documents + api.contracts + '?projectId=' + projectId + '&elem=100&page=0'
    case tableKeys.budget_contracts_lines_table:
      return api.budget_base + api.budget_documents + api.contracts + '?projectId=' + projectId + '&elem=100&page=0'
    case tableKeys.budget_invoices_table:
      return api.budget_base + api.budget_documents + api.budget + '?projectId=' + projectId
    case tableKeys.budget_invoices_lines_table:
      return api.budget_base + api.budget_documents + api.invoices + '?projectId=' + projectId
    case tableKeys.budget_draw_manager_table:
      return api.budget_base + api.budget_documents + api.invoices + api.calculus + '?projectId=' + projectId
    case tableKeys.users_monitor_table:
      return api.base + api.users
    case "ocr_details":
      return "http://ec2-3-65-91-230.eu-central-1.compute.amazonaws.com:8082/api/documents/readInvoiceDetails?invoiceId="+projectId
    case "validate_contract":
      return "http://ec2-3-65-91-230.eu-central-1.compute.amazonaws.com:8082/api/documents/contracts"
    case "validate_invoice":
      return "http://ec2-3-65-91-230.eu-central-1.compute.amazonaws.com:8082/api/documents/invoice"
    default:
      return 'foo'
  }
}

const create_url = (key) => {
  switch(key) {
    case tableKeys.budget_lines_table:
      return api.projects_base + api.budget_categories
    default:
      return 'foo'
  }
}

const update_url = (key) => {
  switch(key) {
    case tableKeys.budget_lines_table:
      return api.projects_base + api.budget_categories + api.budget_category_update
    default:
      return 'foo'
  }
}

const delete_url = (key, rowId) => {
  switch(key) {
    case tableKeys.budget_lines_table:
      return api.projects_base + api.budget_categories + api.delete_budget_category + '/' + rowId
    default:
      return 'foo'
  }
}

export function validateInvoiceApi(obj) {
  const { values, data } = obj
  const body = JSON.stringify({ 
    "budget_line": data.budget_line,
    "contract_description": values.contract_description,
    "contract_serial_number": values.contract_number,
    "document_name": data.document_name,
    "project_id": data.project_id,
    "record_id": data.record_id,
    "signing_date": values.contract_date,
    "status": data.status,
    "supplier": values.supplier
  })
  console.log({ 
    "budget_line": data.budget_line,
    "contract_description": values.contract_description,
    "contract_serial_number": values.contract_number,
    "document_name": data.document_name,
    "project_id": data.project_id,
    "record_id": data.record_id,
    "signing_date": values.contract_date,
    "status": data.status,
    "supplier": values.supplier
  })
  return fetch(url("validate_invoice"), {
    method: 'POST',
    headers: {
      ...headers,
      'Authorization': TOKEN_TYPE + ' ' + localToken()
    },
    body: body,
  }).then(response => response.json())
    .catch((error) => {throw error})
}

export function validateContractApi(obj) {
  const { values, data } = obj
  const body = JSON.stringify({ 
    "budget_line": data.budget_line,
    "contract_description": values.contract_description,
    "contract_serial_number": values.contract_number,
    "document_name": data.document_name,
    "project_id": data.project_id,
    "record_id": data.record_id,
    "signing_date": values.contract_date,
    "status": data.status,
    "supplier": values.supplier
  })
  console.log({ 
    "budget_line": data.budget_line,
    "contract_description": values.contract_description,
    "contract_serial_number": values.contract_number,
    "document_name": data.document_name,
    "project_id": data.project_id,
    "record_id": data.record_id,
    "signing_date": values.contract_date,
    "status": data.status,
    "supplier": values.supplier
  })
  return fetch(url("validate_contract"), {
    method: 'POST',
    headers: {
      ...headers,
      'Authorization': TOKEN_TYPE + ' ' + localToken()
    },
    body: body,
  }).then(response => response.json())
    .catch((error) => {throw error})
}

export function getTableDataApi(key, projectId) {
  return fetch(url(key, projectId), {
    method: 'GET',
    headers: {
      ...headers,
      'Authorization': TOKEN_TYPE + ' ' + localToken()
    },
  }).then(response => response.json())
    .catch((error) => {throw error})
}

function createTableDataApi(key, values, id) {
  const { data, type } = values
  const body = JSON.stringify({ 
    "amount": formatNumber(data.amount),
    "executed_amount": formatNumber(data.executed_amount),
    "initial_contribution": 0,
    "label": data.label,
    "project_id": id,
    "type": type
  })

  return fetch(create_url(key), {
    method: 'POST',
    headers: {
      ...headers,
      'Authorization': TOKEN_TYPE + ' ' + localToken()
    },
    body: body,
  }).then(response => response.json())
    .catch((error) => {throw error})
}

function updateTableDataApi(key, values) {
  const { data, type } = values
  const value = type ? type : data.type
  const body = JSON.stringify({
    "amount": formatNumber(data.amount),
    "budget_category_id": data.id,
    "initial_contribution": 0,
    "label": data.label,
    "type": value,
  })

  return fetch(update_url(key), {
    method: 'POST',
    headers: {
      ...headers,
      'Authorization': TOKEN_TYPE + ' ' + localToken()
    },
    body: body,
  }).then(response => response.json())
    .catch((error) => {throw error})
}

function deleteTableRowApi(table_key, rowId) {
  return fetch(delete_url(table_key, rowId), {
    method: 'GET',
    headers: {
      ...headers,
      'Authorization': TOKEN_TYPE + ' ' + localToken()
    },
  }).then(response => response.json())
    .catch((error) => {throw error})
}

function* getTableData({ key, projectId }) {
  try {
    const data = yield call(() => getTableDataApi(key, projectId))
    let tableData
    if( key === tableKeys.budget_draw_manager_table ) {
      tableData = data
    } else {
      tableData = data.object_list
    }
    yield put({ type: 'GET_TABLE_DATA_SUCCESS', data: tableData, key: key })

  } catch(error) {
    yield put({ type: 'GET_TABLE_DATA_FAILED', message: error.message })
  }
}

function* updateTableData({ key, values, id }) {
  try {
    if(typeof values.data.newRow === 'undefined') {
      yield call(() => updateTableDataApi(key, values))
    } else {
      yield call(() => createTableDataApi(key, values, id))
    }

    yield put({ type: 'UPDATE_TABLE_DATA_SUCCESS' })
    yield put(fetchTableData(key, id))

  } catch(e) {
    yield put({ type: 'UPDATE_TABLE_DATA_FAILED', message: e.message })
  }
}

function* deleteTableRow({ rowId, table_key, project_id }) {
  try {
    yield call(() => deleteTableRowApi(table_key, rowId))

    yield put({ type: 'DELETE_TABLE_DATA_ROW_SUCCESS' })
    yield put(fetchTableData(table_key, project_id))

  } catch(e) {
    yield put({ type: 'DELETE_TABLE_DATA_ROW_FAILED', message: e.message })
  }
}

function* watchFetchTableData() {
  yield takeEvery('GET_TABLE_DATA_REQUESTED', getTableData)
}

function* watchUpdateTableData() {
  yield takeLatest('UPDATE_TABLE_DATA_REQUESTED', updateTableData)
}

function* watchDeleteRow() {
  yield takeLatest('DELETE_TABLE_DATA_ROW_REQUESTED', deleteTableRow)
}

export default function* tablesSaga() {
  yield all([
    watchFetchTableData(),
    watchUpdateTableData(),
    watchDeleteRow()
  ])
}
